import React, { useEffect, useRef, useState } from "react";
import { Col } from "react-bootstrap";
import ApplicationStepper from "../../molecules/ApplicationStepper";
import ApplicationsSteps from "../../molecules/ApplicationSteps";
import BeforeStartApplication from "../../molecules/BeforeStartApplication";
import PensionWiseGuidance from "../../molecules/PensionWiseGuidance";
import LoadingSpinner from "../../atoms/Loader";
import NotFound from "../../atoms/NotFound";
import { MEMBERTYPE, RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";
import LumpSumAllowances from "../../molecules/LumpSumAllowances";
import PotSelectionRetirement from "../../molecules/PotSelectionRetirement";
import YourRetirementChoices from "../../molecules/YourRetirementChoices";
import { ModalOverlay } from "../../atoms/Modal";
import ConfirmYourChoices from "../../molecules/ConfirmYourChoices";
import Illustrations from "../../molecules/Illustrations";
import RetirementTaxFreeCash from "../../molecules/RetirementTaxFreeCash";
import InvestRest from "../../molecules/InvestRest";
import BankMandateDetails from "../../molecules/BankMandateDetails";
import BankMandateConfirmDetails from "../../molecules/BankMandateConfirmDetails";
import IdentificationAndVerification from "../../molecules/IdentificationAndVerification";
import ConfirmDecisions from "../../molecules/ConfirmDecisions";
import Declaration from "../../molecules/Declaration";
import TakeMoneyInChunks from "../../molecules/TakeMoneyInChunks";
import ChoiceContributions from "../../molecules/ChoiceContributions";
import AnnuityHowMuchCash from "../../molecules/AnnuityHowMuchCash";
import Annuity from "../../molecules/Annuity";
import RegularHowMuchCash from "../../molecules/RegularHowMuchCash";
import TakingRegularIncome from "../../molecules/TakingRegularIncome";
import MixMatchHowMuchCash from "../../molecules/MixMatchHowMuchCash";
import MixandMatch from "../../molecules/MixandMatch";

const RetirementApplicationOrganism = (props) => {
  const { data: dataSP } = useSelector(
    (state) => state.schemeProtection, // eslint-disable-line
  );
  const { data: cardData } = useSelector((state) => state.guidanceExplorerCard);
  const {
    fetching,
    data,
    error,
    patchError,
    steps: initialAppSteps,
    applicationSteps,
    guide,
  } = useSelector(
    (state) => state.retirementApplication, // eslint-disable-line
  );
  const { retirementId, investorId } = data;
  const {
    isShowBeforeStart,
    isPensionWise,
    isLumpSumAllowances,
    isPotSelection,
    isRetirementChoice,
    isConfirmChoice,
    isContribution,
    isIllustration,
    isBankMandate,
    isTakeTaxFreeCashInvestRest,
    isTakeMoneyInOneChunk,
    isInvestRest,
    isAnnuityHowMuchCash,
    isAnnuity,
    isRegularHowMuchCash,
    isTakingRegularIncome,
    isMixMatchHowMuchCash,
    isMixandMatch,
    isBankMandateConfirm,
    isIdv,
    isConfirmDeclaration,
    isDeclaration,
  } = applicationSteps;
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [investorAccountId, setInvestorAccountId] = useState("");
  const [lumpSumAmount, setLumpSumAmount] = useState();
  const [isFinalPage, setIsFinalPage] = useState(false);
  const [editingPage, setEditingPage] = useState("");
  const [isPotSelectionCompleted, setIsPotSelectionCompleted] = useState(false);
  const [bankMandateConfirmationChecked, setBankMandateConfirmationChecked] =
    useState(false);
  const [swiftInfoChecked, setSwiftInfoChecked] = useState(false);

  const dispatch = useDispatch();
  const {
    patchRetireApplicationStep,
    setRetirementDetails,
    handleBeginButtonClick,
    handleBackButtonClick,
    getRetireApplicationContent,
    getGuidanceExplorerCardContent,
  } = bindActionCreators(
    actionCreators,
    dispatch, // eslint-disable-line
  );

  const isActiveMember =
    props?.memberType == MEMBERTYPE?.ACTIVE_SAVINGS ||
    props?.memberType == MEMBERTYPE?.ACTIVE_SAVINGS_DRAWDOWN
      ? true
      : false;

  const handleBeginClick = (e, item) => {
    handleBeginButtonClick(item.identifier);
    props.getContinueEnabled(false);
  };

  useEffect(() => {
    if (isShowBeforeStart) {
      props.getContinueEnabled(true);
    } else {
      props.getContinueEnabled(false);
    }
    if (investorId && Object.keys(cardData)?.length === 0) {
      getGuidanceExplorerCardContent(investorId);
    }
  }, []);

  useEffect(() => {
    if (dataSP?.schemeSpecificProtections?.some((e) => e.lumpSum != null)) {
      dataSP?.schemeSpecificProtections?.some((e) => {
        if (e.lumpSum != null) {
          setInvestorAccountId(e.investorAccountId);
          setLumpSumAmount(e.lumpSum);
        }
      });
    } else {
      setInvestorAccountId(
        dataSP?.schemeSpecificProtections?.[0]?.investorAccountId, // eslint-disable-line
      );
    }
  }, [dataSP]);

  useEffect(() => {
    if (error || patchError) {
      setShowErrorModal(true);
    }
  }, [error, patchError]);

  useEffect(() => {
    if (isFinalPage || isPotSelectionCompleted) {
      getRetireApplicationContent(investorId, editingPage, retirementId);
      setIsPotSelectionCompleted(false);
      setIsFinalPage(false);
    }
  }, [
    initialAppSteps[2]?.isComplete,
    initialAppSteps[2]?.subSteps[0]?.isSubComplete,
  ]);

  if (fetching) {
    return <LoadingSpinner width={85} />;
  }

  const makeInitialStepper = (
    isHomeScreen,
    mainStep,
    disableSection,
    backButtonClicked,
  ) => {
    if (isHomeScreen) {
      handleBackButtonClick(isHomeScreen);
    } else {
      handleBackButtonClick(
        isHomeScreen,
        mainStep,
        disableSection,
        backButtonClicked,
      );
    }
  };

  const [miId, setMiId] = useState();
  const [faiId, setFaiId] = useState();
  const [snId, setSnId] = useState();
  const [leId, setLeId] = useState();

  const nextStepIndentifier = (identifier, stepObject, date, editingPage) => {
    try {
      switch (identifier) {
        case RA_STEPS_IDENTIFIERS.RA_APPLICATION_DATE:
          if (stepObject) {
            let guide = {
              pensionPaymentRequiredImmediately: true,
              pensionStartDate: null,
              receivedGuidanceFromPensionWise: false,
              receivedAdviceFromFCA: false,
              wishToOptOutGuidanceFromPW: false,
            };
            let payload = {
              investorId: investorId,
              retirementId: retirementId,
              currentStep: RA_STEPS_IDENTIFIERS.RA_APPLICATION_DATE,
              guide,
            };
            setRetirementDetails(
              RA_STEPS_IDENTIFIERS.RA_APPLICATION_DATE,
              guide, // eslint-disable-line
            );
            patchRetireApplicationStep(investorId, payload);
          } else {
            let guide = {
              pensionPaymentRequiredImmediately: false,
              pensionStartDate: date,
              receivedGuidanceFromPensionWise: false,
              receivedAdviceFromFCA: false,
              wishToOptOutGuidanceFromPW: false,
            };
            let payload = {
              investorId: investorId,
              retirementId: retirementId,
              currentStep: RA_STEPS_IDENTIFIERS.RA_APPLICATION_DATE,
              guide,
            };
            setRetirementDetails(
              RA_STEPS_IDENTIFIERS.RA_APPLICATION_DATE,
              guide, // eslint-disable-line
            );
            patchRetireApplicationStep(investorId, payload);
          }
          break;
        case RA_STEPS_IDENTIFIERS.RA_PENSION_WISE:
          if (investorId && retirementId) {
            let _guide = {
              pensionPaymentRequiredImmediately: guide
                ? guide.pensionPaymentRequiredImmediately
                : false,

              pensionStartDate: guide?.pensionStartDate,
              receivedGuidanceFromPensionWise: stepObject?.includes(
                "receivedGuidanceFromPensionWise", // eslint-disable-line
              ),
              receivedAdviceFromFCA: stepObject?.includes(
                "receivedAdviceFromFCA", // eslint-disable-line
              ),
              wishToOptOutGuidanceFromPW: stepObject?.includes(
                "wishToOptOutGuidanceFromPW", // eslint-disable-line
              ),
            };
            // eslint-disable-next-line no-case-declarations
            let payload = {
              investorId: investorId,
              retirementId: retirementId,
              currentStep: RA_STEPS_IDENTIFIERS.RA_PENSION_WISE,
              guide: _guide,
            };
            setRetirementDetails(RA_STEPS_IDENTIFIERS.RA_PENSION_WISE, _guide);
            patchRetireApplicationStep(investorId, payload, editingPage);
          }

          break;
        case RA_STEPS_IDENTIFIERS.RA_LUMP_SUM_ALLOWANCES:
          if (investorId && retirementId) {
            let pensionObject = {
              notReceivedLumpSumFromPensionProvider: stepObject?.includes(
                "notReceivedLumpSumFromPensionProvider", // eslint-disable-line
              ),
              receivedLumpSumFromUkPensionProvider: stepObject?.includes(
                "receivedLumpSumFromUkPensionProvider", // eslint-disable-line
              ),
            };
            // eslint-disable-next-line no-case-declarations
            let payload = {
              investorId: investorId,
              retirementId: retirementId,
              currentStep: RA_STEPS_IDENTIFIERS.RA_LUMP_SUM_ALLOWANCES,
              pension: pensionObject,
            };
            setRetirementDetails(
              RA_STEPS_IDENTIFIERS.RA_LUMP_SUM_ALLOWANCES,
              pensionObject, // eslint-disable-line
            );
            patchRetireApplicationStep(investorId, payload, editingPage);
          }
          break;
        case RA_STEPS_IDENTIFIERS.RA_OFFLINE_PENSION:
          // eslint-disable-next-line no-case-declarations
          let offLinePayload = {
            investorId: investorId,
            retirementId: retirementId,
            currentStep: RA_STEPS_IDENTIFIERS.RA_OFFLINE_PENSION,
            //TODO Investment Account Id lumpsum and should be calculated
            selectedScheme: {
              investorAccountId: investorAccountId,
              lumpsum: lumpSumAmount ? lumpSumAmount : "0.00",
            },
          };

          patchRetireApplicationStep(investorId, offLinePayload);
          break;
        case RA_STEPS_IDENTIFIERS.RA_POT_SELECTION:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let potSelectionPayload = {
            investorId: investorId,
            retirementId: retirementId,
            currentStep: RA_STEPS_IDENTIFIERS.RA_POT_SELECTION,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_POT_SELECTION,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(
            investorId,
            potSelectionPayload,
            editingPage,
          );

          break;
        case RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let raConfirmChoosePayload = {
            investorId: investorId,
            retirementId: retirementId,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE,
            stepObject, // eslint-disable-line
          );

          patchRetireApplicationStep(investorId, raConfirmChoosePayload);

          break;
        case RA_STEPS_IDENTIFIERS.RA_TAX_FREE_CASH:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let raTaxFreeCashPayload = {
            investorId: investorId,
            retirementId: retirementId,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_TAX_FREE_CASH,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(investorId, raTaxFreeCashPayload);
          break;
        case RA_STEPS_IDENTIFIERS.RA_INVEST_THE_REST:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let raInvestRest = {
            investorId: investorId,
            retirementId: retirementId,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_INVEST_THE_REST,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(investorId, raInvestRest);
          break;
        case RA_STEPS_IDENTIFIERS.RA_TAKE_MONEY_IN_CHUNKS:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let raMoneyInChunksPayload = {
            investorId: investorId,
            retirementId: retirementId,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_TAKE_MONEY_IN_CHUNKS,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(investorId, raMoneyInChunksPayload);
          break;
        case RA_STEPS_IDENTIFIERS.RA_ANNUITY_CHOICE:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let raAnnuityChocePayload = {
            investorId: investorId,
            retirementId: retirementId,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_ANNUITY_CHOICE,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(investorId, raAnnuityChocePayload);
          break;
        case RA_STEPS_IDENTIFIERS.RA_ANNUITY_PROVIDER:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let raAnnuityProviderPayload = {
            investorId: investorId,
            retirementId: retirementId,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_ANNUITY_PROVIDER,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(investorId, raAnnuityProviderPayload);
          break;
        case RA_STEPS_IDENTIFIERS.RA_RI_CASH_LUMPSUM:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let raricashLumPayload = {
            investorId: investorId,
            retirementId: retirementId,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_RI_CASH_LUMPSUM,
            stepObject // eslint-disable-line
          );
          patchRetireApplicationStep(investorId, raricashLumPayload);

          break;
        case RA_STEPS_IDENTIFIERS.RA_RI_INVEST_THE_REST:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let raRIinvestPayload = {
            investorId: investorId,
            retirementId: retirementId,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_RI_INVEST_THE_REST,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(investorId, raRIinvestPayload);
          break;
        case RA_STEPS_IDENTIFIERS.RA_MM_CASH_LUMPSUM:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let raMixandMatchCashLumSumPayload = {
            investorId: investorId,
            retirementId: retirementId,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_MM_CASH_LUMPSUM,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(
            investorId,
            raMixandMatchCashLumSumPayload, // eslint-disable-line
          );
          break;
        case RA_STEPS_IDENTIFIERS.RA_BEND_STRATEGIES:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let raMixandMatchPayload = {
            investorId: investorId,
            retirementId: retirementId,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_BEND_STRATEGIES,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(investorId, raMixandMatchPayload);
          break;
        case RA_STEPS_IDENTIFIERS.RA_CONTRIBUTION:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let raContributionsPayload = {
            investorId: investorId,
            retirementId: retirementId,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_CONTRIBUTION,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(investorId, raContributionsPayload);
          break;
        case RA_STEPS_IDENTIFIERS.RA_ILLUSTRATION:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let raIllustration = {
            investorId: investorId,
            retirementId: retirementId,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_ILLUSTRATION,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(investorId, raIllustration);
          break;
        case RA_STEPS_IDENTIFIERS.BANK_MANDATE:
          // eslint: no-case-declaration
          // eslint-disable-next-line
          let bankMandatePayload = {
            investorId: investorId,
            retirementId: retirementId,
            currentStep: RA_STEPS_IDENTIFIERS.BANK_MANDATE,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.BANK_MANDATE,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(investorId, bankMandatePayload);
          break;
        case RA_STEPS_IDENTIFIERS.BANK_MANDATE_CONFIRM:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let bankMandateConfirmPayload = {
            investorId: investorId,
            retirementId: retirementId,
            currentStep: RA_STEPS_IDENTIFIERS.BANK_MANDATE_CONFIRM,
            ...stepObject,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.BANK_MANDATE_CONFIRM,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(
            investorId,
            bankMandateConfirmPayload,
            editingPage,
          );
          break;
        case RA_STEPS_IDENTIFIERS.RA_IDENTITY_AND_VERIFICATION:
          //eslint: no-case-declaration
          //eslint-disable-next-line
          let identityandvPayload = {
            investorId: investorId,
            retirementId: retirementId,
            currentStep: RA_STEPS_IDENTIFIERS.RA_IDENTITY_AND_VERIFICATION,
          };
          setRetirementDetails(
            RA_STEPS_IDENTIFIERS.RA_IDENTITY_AND_VERIFICATION,
            stepObject, // eslint-disable-line
          );
          patchRetireApplicationStep(investorId, identityandvPayload);
          break;
        case RA_STEPS_IDENTIFIERS.DECLARATION:
          props.handelOtherScreenAction(RA_STEPS_IDENTIFIERS.DECLARATION);
          break;
        case RA_STEPS_IDENTIFIERS.RA_CONFIRM_DETAILS:
          // eslint-disable-next-line no-case-declarations
          let confirmDetails = {
            investorId: investorId,
            retirementId: retirementId,
            currentStep: RA_STEPS_IDENTIFIERS.RA_CONFIRM_DETAILS,
            ...stepObject,
          };
          patchRetireApplicationStep(investorId, confirmDetails);
          break;
        case RA_STEPS_IDENTIFIERS.RA_APPLICATION_SUCCESS:
          // eslint-disable-next-line no-case-declarations
          let raSuccess = {
            investorId: investorId,
            retirementId: retirementId,
            currentStep: RA_STEPS_IDENTIFIERS.RA_APPLICATION_SUCCESS,
          };
          patchRetireApplicationStep(investorId, raSuccess);
          break;

        default:
          break;
      }
    } catch (error) {
      console.log("Error", error);
    }
  };
  const illutrationOpened = useRef(false);

  return (
    <>
      {props.error ? (
        <>
          <NotFound err={props.error} />
        </>
      ) : (
        <>
          {isShowBeforeStart ? (
            <Col className="mt-4">
              <BeforeStartApplication getIsAgreed={props.getIsAgreed} />
            </Col>
          ) : (
            <>
              <Col xl={3} lg={3} md={3} sm={3} xs={12} className="mt-4">
                <ApplicationStepper raSteps={initialAppSteps} />
              </Col>
              <Col xl={9} lg={9} md={9} sm={9} xs={12} className="mt-4">
                {isPensionWise ? (
                  <PensionWiseGuidance
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    editingPage={editingPage}
                    setEditingPage={setEditingPage}
                  />
                ) : isLumpSumAllowances ? (
                  <LumpSumAllowances
                    makeInitialStepper={makeInitialStepper}
                    nextStepIndentifier={nextStepIndentifier}
                    editingPage={editingPage}
                    setEditingPage={setEditingPage}
                  />
                ) : isPotSelection ? (
                  <PotSelectionRetirement
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    investorId={investorId}
                    setIsPotSelectionCompleted={setIsPotSelectionCompleted}
                    editingPage={editingPage}
                    setEditingPage={setEditingPage}
                  />
                ) : isRetirementChoice ? (
                  <YourRetirementChoices
                    nextStepIndentifier={nextStepIndentifier}
                    investorId={investorId}
                    data={data}
                    memberType={props.memberType}
                    isActiveMember={isActiveMember}
                  />
                ) : isTakeTaxFreeCashInvestRest ? (
                  <RetirementTaxFreeCash
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    chooseData={data}
                    isActiveMember={isActiveMember}
                  />
                ) : isTakeMoneyInOneChunk ? (
                  <TakeMoneyInChunks
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    retirementData={data}
                  />
                ) : isConfirmChoice ? (
                  <ConfirmYourChoices
                    memberType={props.memberType}
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    chooseData={data}
                    isActiveMember={isActiveMember}
                    setIsFinalPage={setIsFinalPage}
                    isFinalPage={isFinalPage}
                    investorId={investorId}
                    miId={miId}
                    faiId={faiId}
                    snId={snId}
                    leId={leId}
                    retirementId={retirementId}
                  />
                ) : isContribution ? (
                  <ChoiceContributions
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    setIsFinalPage={setIsFinalPage}
                    isFinalPage={isFinalPage}
                    editingPage={editingPage}
                    setEditingPage={setEditingPage}
                  />
                ) : isInvestRest ? (
                  <InvestRest
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    investorId={investorId}
                    setMiId={setMiId}
                    setFaiId={setFaiId}
                    setSnId={setSnId}
                    setLeId={setLeId}
                    miId={miId}
                    faiId={faiId}
                    snId={snId}
                    leId={leId}
                    cardData={cardData}
                  />
                ) : isAnnuityHowMuchCash ? (
                  <AnnuityHowMuchCash
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                  />
                ) : isAnnuity ? (
                  <Annuity
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                  />
                ) : isRegularHowMuchCash ? (
                  <RegularHowMuchCash
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                  />
                ) : isTakingRegularIncome ? (
                  <TakingRegularIncome
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    investorId={investorId}
                    cardData={cardData}
                    setMiId={setMiId}
                    setFaiId={setFaiId}
                    setSnId={setSnId}
                    setLeId={setLeId}
                    miId={miId}
                    faiId={faiId}
                    snId={snId}
                    leId={leId}
                  />
                ) : isMixMatchHowMuchCash ? (
                  <MixMatchHowMuchCash
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                  />
                ) : isMixandMatch ? (
                  <MixandMatch
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    investorId={investorId}
                    setMiId={setMiId}
                    setFaiId={setFaiId}
                    setSnId={setSnId}
                    setLeId={setLeId}
                    miId={miId}
                    faiId={faiId}
                    snId={snId}
                    leId={leId}
                    cardData={cardData}
                    retirementId={retirementId}
                  />
                ) : isBankMandate ? (
                  <BankMandateDetails
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    swiftInfoChecked={swiftInfoChecked}
                    setSwiftInfoChecked={setSwiftInfoChecked}
                  />
                ) : isIllustration ? (
                  <Illustrations
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    rData={data}
                    isActiveMember={isActiveMember}
                    setIsFinalPage={setIsFinalPage}
                    isFinalPage={isFinalPage}
                    investorId={investorId}
                    miId={miId}
                    faiId={faiId}
                    snId={snId}
                    leId={leId}
                    retirementId={retirementId}
                  />
                ) : isBankMandateConfirm ? (
                  <BankMandateConfirmDetails
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    editingPage={editingPage}
                    setEditingPage={setEditingPage}
                    setBankMandateConfirmationChecked={
                      setBankMandateConfirmationChecked
                    }
                    bankMandateConfirmationChecked={
                      bankMandateConfirmationChecked
                    }
                  />
                ) : isIdv ? (
                  <IdentificationAndVerification
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    investorId={investorId}
                    retirementId={retirementId}
                  />
                ) : isConfirmDeclaration ? (
                  <ConfirmDecisions
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                    data={data}
                    setEditingPage={setEditingPage}
                    bankMandateConfirmationChecked={
                      bankMandateConfirmationChecked
                    }
                    swiftInfoChecked={swiftInfoChecked}
                    retirementId={retirementId}
                    investorId={investorId}
                    illutrationOpened={illutrationOpened}
                  />
                ) : isDeclaration ? (
                  <Declaration
                    nextStepIndentifier={nextStepIndentifier}
                    makeInitialStepper={makeInitialStepper}
                  />
                ) : (
                  <ApplicationsSteps
                    investorId={investorId}
                    retirementData={props}
                    handleBeginClick={handleBeginClick}
                    illutrationOpened={illutrationOpened}
                  />
                )}
              </Col>
            </>
          )}

          <ModalOverlay
            popup="QRCodeStatusModal"
            show={showErrorModal}
            onHide={(e) => {
              if (e !== undefined) {
                e.preventDefault();
              }
              setShowErrorModal(false);
            }}
            status="Error"
            statusTitle={"Unfortunately we were not able to update the status"}
            statusText={"Please try again later"}
          />
        </>
      )}
    </>
  );
};

export default RetirementApplicationOrganism;
